module.exports = __webpack_public_path__ + "img/task-11.58183894.png";